import { Base } from '../base.model';

// Internal Chat models (SPEC-2026-07-internal-chat, T-16).
// Manual mirror of trendmulti-apps/libs/trendmulti-entity/src/entity/chat/
// chat-message.entity.ts — enum values MUST stay byte-identical to the
// backend contract.

export enum ChatMessageTypeEnum {
  TEXT = 'TEXT',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  DOCUMENT = 'DOCUMENT',
}

export enum ChatContextRefKindEnum {
  ATTENDANCE = 'ATTENDANCE',
  CARD = 'CARD',
  CONTACT = 'CONTACT',
}

// Shape shared by the REST reads (lean documents) and the socket fan-out
// (`chat:message:new` / `chat:message:updated` carry exactly this, with every
// ref serialized as an ObjectId string — see chat DeliveryService).
// NOTE: `replyTo`/`forwardedFrom` are NOT hydrated by the backend — quote
// previews are resolved client-side from already-loaded messages, otherwise a
// neutral placeholder is shown.
export interface ChatMessage extends Base {
  /** ChatChannel id */
  channel: string;
  /** User id (appdb) — string only, never populated */
  sender: string;
  /** Company id (appdb) — string only, never populated */
  company: string;
  type: ChatMessageTypeEnum;
  /** sanitized markdown subset — raw HTML is never stored */
  content: string;
  fileUrl?: string;
  contentType?: string;
  fileName?: string;
  fileSize?: number;
  /** client-generated id — idempotency key for send retries */
  clientMessageId: string;
  /** thread root this message replies to (distinct from quote reply — replyTo) */
  parentMessage?: string;
  threadCount: number;
  threadLastReplyAt?: Date;
  /** quoted message id (distinct from thread reply — parentMessage) */
  replyTo?: string;
  forwardedFrom?: string;
  /**
   * Original author of a forwarded message (User id) — the identity snapshot
   * behind the "Encaminhada de X" banner. Denormalized server-side because the
   * source conversation may not be readable by the recipient; names resolve
   * via userDisplay (message endpoints hydrate this id too).
   */
  forwardedFromSender?: string;
  reactions: Array<ChatMessageReaction>;
  /** User ids — always active channel members (invalid mentions are dropped server-side) */
  mentions: Array<string>;
  /** pointer to a work record (Attendance/Card/Contact in appdb) with a display snapshot */
  contextRef?: ChatContextRef;
  editedAt?: Date;
  /**
   * Deleted-by-author tombstone (RF-10). The API keeps the message in the
   * history (position + author preserved, WhatsApp-style) but strips content,
   * attachments and the work reference before it leaves the server — clients
   * render the "mensagem apagada" placeholder and nothing else.
   */
  deleted?: boolean;
}

export interface ChatMessageReaction {
  emoji: string;
  /** User ids */
  users: Array<string>;
}

export interface ChatContextRef {
  kind: ChatContextRefKindEnum;
  /** ObjectId of the referenced Attendance/Card/Contact (appdb) */
  refId: string;
  snapshot: ChatContextRefSnapshot;
}

export interface ChatContextRefSnapshot {
  label: string;
  subtitle?: string;
}
